
import { Vue, Component, Prop } from "vue-property-decorator";

@Component
export default class TileAvatar extends Vue {
  @Prop(String) readonly image!: string;
  @Prop(String) readonly initial!: boolean;
}
